var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorStateinline = function SvgErrorStateinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AF3535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.001 18.33a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.667M10 6.664v3.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 13.336h.009"
  })));
};
export default SvgErrorStateinline;